export const winteritems = [
  {
    "id": "1",
    "name": "Cozy Knit Sweater",
    "description": "Stay warm and stylish with our cozy knit sweater.",
    "brand": "WarmWool",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "size4": "XL",
    "color1": "Darkslategray",
    "color2": "Tomato",
    "image": "Cozy Knit Sweater.jpg",
    "price": "3649"
  },
  {
    "id": "2",
    "name": "Faux Fur Coat",
    "description": "Make a statement with our luxurious faux fur coat.",
    "brand": "FurFashion",
    "size1": "XS",
    "size2": "S",
    "size3": "M",
    "size4": "L",
    "color1": "Black",
    "color2": "Mistyrose",
    "image": "Faux Fur Coat.jpg",
    "price": "8099"
  },
  {
    "id": "3",
    "name": "Plaid Flannel Shirt",
    "description": "Classic plaid flannel shirt for a timeless look.",
    "brand": "RusticWear",
    "size1": "M",
    "size2": "L",
    "size3": "XL",
    "color1": "Darkolivegreen",
    "color2": "Darkgoldenrod",
    "image": "Plaid Flannel Shirt.avif",
    "price": "3849"
  },
  {
    "id": "4",
    "name": "Chunky Cable-Knit Scarf",
    "description": "Stay cozy with our chunky cable-knit scarf.",
    "brand": "WinterWarmth",
    "size1": "One Size",
    "color1": "Saddlebrown",
    "color2": "Steelblue",
    "image": "Chunky Cable-Knit Scarf.jpg",
    "price": "2749"
  },
  {
    "id": "5",
    "name": "Puffer Jacket",
    "description": "Stay warm and dry with our water-resistant puffer jacket.",
    "brand": "AllWeather",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "size4": "XL",
    "color1": "Dodgerblue",
    "color2": "Khaki",
    "image": "Puffer Jacket.jpg",
    "price": "7299"
  },
  {
    "id": "6",
    "name": "Thermal Long Johns",
    "description": "Keep the cold out with our thermal long johns.",
    "brand": "WinterBasics",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "Lightgrey",
    "color2": "Maroon",
    "image": "Thermal Long Johns.jpg",
    "price": "3149"
  },
  {
    "id": "7",
    "name": "Beanie Hat",
    "description": "Top off your winter look with our cozy beanie hat.",
    "brand": "HeadWarmers",
    "size1": "One Size",
    "color1": "Gold",
    "color2": "Dimgray",
    "image": "Beanie Hat.jpg",
    "price": "1499"
  },
  {
    "id": "8",
    "name": "Insulated Gloves",
    "description": "Protect your hands from the cold with our insulated gloves.",
    "brand": "ColdDefenders",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "Green",
    "color2": "Magenta",
    "image": "Insulated Gloves.jpg",
    "price": "1999"
  },
  {
    "id": "9",
    "name": "Wool Blend Coat",
    "description": "Stay elegant and warm with our wool blend coat.",
    "brand": "WinterChic",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "Purple",
    "color2": "Wheat",
    "image": "Wool Blend Coat.jpg",
    "price": "9999"
  },
  {
    "id": "10",
    "name": "Snow Boots",
    "description": "Conquer the snow with our durable and waterproof snow boots.",
    "brand": "SnowMaster",
    "size1": "US 6-12",
    "color1": "Teal",
    "color2": "Gold",
    "image": "Snow Boots.jpg",
    "price": "5849"
  },
  {
    "id": "11",
    "name": "Fleece-lined Leggings",
    "description": "Stay warm and cozy with our fleece-lined leggings.",
    "brand": "WinterEssentials",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "Rebeccapurple",
    "color2": "Lightseagreen",
    "image": "Fleece-lined Leggings.jpg",
    "price": "1999"
  },
  {
    "id": "12",
    "name": "Quilted Vest",
    "description": "Add a layer of warmth with our quilted vest.",
    "brand": "VersatileWear",
    "size1": "M",
    "size2": "L",
    "size3": "XL",
    "color1": "Blueviolet",
    "color2": "Deeppink",
    "image": "Quilted Vest.jpg",
    "price": "4999"
  },
  {
    "id": "13",
    "name": "Cashmere Sweater",
    "description": "Indulge in luxury with our soft and cozy cashmere sweater.",
    "brand": "LuxuryKnits",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "Midnightblue",
    "color2": "Darkturquoise",
    "image": "Cashmere Sweater.avif",
    "price": "12999"
  },
  {
    "id": "14",
    "name": "Sherpa-Lined Jacket",
    "description": "Stay toasty in our sherpa-lined jacket with a rugged exterior.",
    "brand": "OutdoorStyle",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "Indigo",
    "color2": "Limegreen",
    "image": "Sherpa-Lined Jacket.jpg",
    "price": "6999"
  },
  {
    "id": "15",
    "name": "Mittens",
    "description": "Keep your hands warm with our cozy mittens.",
    "brand": "HandWarmers",
    "size1": "One Size",
    "color1": "Darkolivegreen",
    "color2": "Peru",
    "image": "Mittens.jpg",
    "price": "1299"
  },
  {
    "id": "16",
    "name": "Wool Socks",
    "description": "Stay comfortable all day with our soft and warm wool socks.",
    "brand": "SockCozy",
    "size1": "One Size",
    "color1": "Maroon",
    "color2": "Teal",
    "image": "Wool Socks.jpg",
    "price": "999"
  }
];
